(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/deposit-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/deposit-service.js');

'use strict';

const {
  jupiter
} = svs.core;
const {
  logger
} = svs.accountservicesReact.deposit;

const getCurrentStatus = async () => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path: '/player/3/info?include=currentStatus'
    });
    return response ? response : {
      currentStatus: []
    };
  } catch (err) {
    logger.warn('Error fetching player info for checking currentStatus for DEPOSITS_SUSPENDED', err);
    return {
      currentStatus: []
    };
  }
};

const getSuspensions = async () => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path: '/player/1/suspensions'
    });
    return response ? response : {
      suspensions: []
    };
  } catch (err) {
    logger.warn('Error fetching player suspensions', err);
    return {
      suspensions: []
    };
  }
};

const getNetLossRestrictions = async () => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path: '/gcs/1/activenetlossrestriction'
    });
    return response ? response : null;
  } catch (err) {
    logger.warn('Error getting net loss restrictions', err);
    return null;
  }
};

const getDepositRestrictions = async () => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path: '/gcs/1/depositdialog'
    });
    return response ? response : null;
  } catch (err) {
    logger.warn('Error getting depositdialog for deposit restrictions', err);
    return null;
  }
};

const getDayTimeLimit = async () => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path: "/player/2/daytimelimit"
    });
    return response ? response : null;
  } catch (err) {
    logger.warn('Error getting players day time limit', err);
    return null;
  }
};

const putDepositAmount = async depositAmount => {
  try {
    const {
      response
    } = await svs.core.jupiter.callAsync({
      method: 'PUT',
      path: '/gcs/1/remainingdeposits',
      data: {
        remainingDeposits: depositAmount
      }
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error setting remainingdeposits', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error setting remainingdeposits', err);
    return {
      error: err
    };
  }
};
svs.accountservicesReact.deposit.services.depositService = {
  getSuspensions,
  getCurrentStatus,
  getNetLossRestrictions,
  getDepositRestrictions,
  getDayTimeLimit,
  putDepositAmount
};

 })(window);